import { configure } from "arktype/config";

configure({
	clone: false,
	exactOptionalPropertyTypes: false,
	toJsonSchema: {
		fallback: {
			morph: ({ base }) => base,
			unit: () => ({ not: {} }),
		},
	},
});
